module.exports = __webpack_public_path__ + "img/sintesis.84fc3609.svg";